import { CSSProperties, ReactNode } from 'react';
import {
  Toolbar as MUIToolbar,
  ToolbarProps as MUIToolbarProps,
} from '@mui/material';

type AtomMUIProps = {
  children?: ReactNode;
  style?: CSSProperties;
};

export type ToolbarProps = AtomMUIProps;

export const Toolbar = (props: ToolbarProps) => {
  const MUIProps: MUIToolbarProps = props;

  return <MUIToolbar {...MUIProps} />;
};

export default Toolbar;
